import { ContentLanguage } from '@coin/shared/core/util-enums';

export class CommunicationContent {
  id?: string = null;
  language = ContentLanguage.ENGLISH;
  title = '';
  description = '';
  text = '';
  textJson?: object = {};
  mediaUrl?: string;
  senderAddress?: string;
  senderDisplayName?: string;
  replyToAddress?: string;

  constructor(language = ContentLanguage.ENGLISH) {
    this.language = language;
  }
}
